module.exports = __webpack_public_path__ + "static/media/ic_download_selected.ec3ffdf9.svg";